<template>
  <div class="detail step1Agency">
    <p class="institutiomname">{{ title }}</p>
    <div class="title clearfix">
      <p class="type pull-left">入驻类型:{{ getType }}</p>
      <!-- <p class="time pull-right">填报时间: {{reportTime}}</p> -->
    </div>
    <!-- form -->
    <table-form
      :dataSource="formConf"
      ref="form"
      :tableData="formData"
      :disable="true"
    ></table-form>
    <!-- 出资人信息 -->
    <table-temp
      class="item-table"
      title="出资人信息"
      :flag="1"
      :tableData="investorData"
      :columnData="investorConf"
      text="详情"
      @editTable="editTable"
      :showSummary="true"
      :summaryMethod="getSummaries"
    ></table-temp>
    <!-- 联系人信息 -->
    <table-temp
      class="item-table"
      title="联系人信息"
      :flag="2"
      :tableData="contactData"
      :columnData="contactCommonConf[0]"
      text="详情"
      @editTable="editTable"
      :isEdit="false"
    ></table-temp>

    <!-- 法定代表人(或委派代表信息) -->
    <table-temp
      class="item-table"
      title="法定代表人(或委派代表信息)"
      :flag="3"
      :tableData="legalData"
      :columnData="newContactConf"
      text="详情"
      @editTable="editTable"
    ></table-temp>

    <!-- 合规风控负责人 -->
    <table-temp
      v-if="!isAgency"
      class="item-table"
      title="合规风控负责人"
      :flag="4"
      :tableData="complianceData"
      :columnData="newContactConf"
      text="详情"
      @editTable="editTable"
    ></table-temp>

    <!-- 财务负责人信息 -->
    <table-temp
      v-if="!isAgency"
      class="item-table"
      title="财务负责人信息"
      :flag="5"
      :tableData="financialData"
      :columnData="contactCommonConf[0]"
      text="详情"
      @editTable="editTable"
    ></table-temp>

    <!-- 企业信息 -->
    <table-temp
      v-if="!isAgency"
      class="item-table"
      title="企业信息"
      :flag="5"
      :tableData="companyData"
      :columnData="uploadConfig[0]"
      :isEdit="false"
    ></table-temp>

    <!-- 办公场所 -->
    <table-temp
      class="item-table"
      title="办公场所"
      :flag="6"
      :tableData="officeData"
      :columnData="uploadConfig[1]"
      :isEdit="false"
    ></table-temp>

    <!-- 其他资料 -->
    <table-temp
      v-if="this.fundType == '私募股权投资基金'"
      class="item-table"
      title="其他资料"
      :flag="5"
      :tableData="otherInfoItem[0]"
      :columnData="step4Other"
      :isEdit="false"
    ></table-temp>
    <table-temp
      v-if="this.fundType == '创业投资基金'"
      class="item-table"
      title="其他资料"
      :flag="5"
      :tableData="otherInfoItem[0]"
      :columnData="step4Other"
      :isEdit="false"
    ></table-temp>
    <table-temp
      v-if="this.fundType == '私募证券投资基金'"
      class="item-table"
      title="其他资料"
      :flag="5"
      :tableData="otherInfoItem[1]"
      :columnData="step4Other"
      :isEdit="false"
    ></table-temp>
    <table-temp
      v-if="this.fundType == '持股平台'"
      class="item-table"
      title="其他资料"
      :flag="5"
      :tableData="otherInfoItem[2]"
      :columnData="step4Other"
      :isEdit="false"
    ></table-temp>
    <table-temp
      v-if="this.fundType == '自有资金投资类企业'"
      class="item-table"
      title="其他资料"
      :flag="5"
      :tableData="otherInfoItem[3]"
      :columnData="step4Other"
      :isEdit="false"
    ></table-temp>
    <!--详情 -->
    <common-dialog
      :dialogVisible="dialogVisible"
      :dtitle="dtitle"
      :tableData="commonData"
      :dataSource="commoncolumn"
      @closeDialog="closeDialog"
      :isAgency="isAgency"
    ></common-dialog>
    <!-- 出资人信息详情 -->
    <common-dialog1
      :dialogOnes="dialogOnes"
      :dtitle="dtitle"
      :tableData="commonData"
      :dataSource="commoncolumn"
      @closeDialog1="closeDialog1"
      :fundType="fundType"
    ></common-dialog1>
  </div>
</template>

<script>
const flags = {
  new: "新设",
  update: "变更",
  add: "迁入",
};

import TableForm from "common/components/form/tableForm";
import { step2, step3, uploadConfig, step4Other } from "@/conf/newAgency";
import { legalDataItem } from "@/conf/AgencyConf";
import { otherInfoItem } from "@/conf/AgencyConf";
import { newStep1 } from "@/conf/Agency";
import { AgencyStep2 } from "@/conf/Agency";
import TableTemp from "@table/table2";
import CommonDialog from "@/views/FundManagement/components/dialog/common-dialog";
import CommonDialog1 from "@/views/FundManagement/components/dialog/common-dialog1";
import { selectDic } from "common/js/api";

export default {
  props: {
    data: {
      type: Object,
    },
  },

  components: {
    TableForm,
    TableTemp,
    CommonDialog,
    CommonDialog1,
  },

  computed: {
    getType() {
      const type = this.$route.query.flag;
      return flags[type] || "";
    },
  },

  data() {
    return {
      title: "",
      // form
      formConf: newStep1,
      formData: {},
      // 出资人
      investorConf: [],
      contactCommonConf: step3,
      uploadConfig,
      investorData: [],
      //联系人信息
      contactData: [
        {
          name: "出资人",
        },
      ],
      // 法定代表人
      legalData: [
        {
          name: "出资人",
        },
      ],
      // 合规
      complianceData: [
        {
          name: "出资人",
        },
      ],
      // 财务负责人
      financialData: [
        {
          name: "出资人",
        },
      ],
      //
      companyData: [],
      officeData: [],
      otherData: [],
      otherInfoItem,
      otherInfo: {},
      // dialog
      dialogVisible: false,
      dtitle: "",
      commonData: [],
      commoncolumn: [],
      isAgency: false,
      dialogOnes: false,
      newContactConf: [],
      fundType: "",
      //转换一次
      isChange: false,
      isDone: false,
      step4Other,
    };
  },

  created() {},

  mounted() {
    this.isAgency =
      this.$route.path == "/FundManagement/FundDetail" ? "false" : "true";
    this.investorConf =
      this.$route.path == "/FundManagement/FundDetail" ? step2 : AgencyStep2;

    if (this.isAgency) {
      this.newContactConf = legalDataItem;
    } else {
      this.newContactConf = this.contactCommonConf[1].filter((item) => {
        return (
          item.field !== "experienceInvest" &&
          item.field !== "experienceEducation" &&
          item.field !== "experienceJob"
        );
      });
    }
  },

  methods: {
    async getSelect() {
      const query = "3";
      // const query = "3,10";
      const result = await selectDic(query);
      const { INVESTOR_CHARACTER, INVESTOR_TYPE } = result.result;
      this.commoncolumn = this.investorConf;
      this.converSelect(INVESTOR_CHARACTER, 1);
      // this.converSelect(INVESTOR_TYPE, 5);
    },

    converSelect(option, index) {
      option.forEach((item) => {
        let data = {
          label: item,
          value: item,
        };
        this.commoncolumn[index].options.push(data);
      });
    },

    editTable(data) {
      const flag = data.flag;
      this.commonData = this.$lodash.cloneDeep(data.scope.row);
      this.commonData.qualified = this.commonData.qualified ? "1" : "0";
      console.log(" this.commonData -- ", this.commonData);
      switch (flag) {
        case 1:
          this.getSelect();
          this.dtitle = "出资人详情";
          this.dialogOnes = true;
          break;
        case 2:
          this.commoncolumn = this.contactCommonConf[0];
          this.dtitle = "联系人详情";
          this.dialogVisible = true;
          break;
        case 3:
          this.commoncolumn = this.contactCommonConf[3];
          //this.dataSource = this.$lodash.cloneDeep(step3[3]);
          this.dtitle = "法定代表人详情";
          this.dialogVisible = true;
          break;
        case 4:
          this.commoncolumn = this.contactCommonConf[1];
          this.dtitle = "合规风控负责人详情";
          this.dialogVisible = true;
          break;
        case 5:
          this.commoncolumn = this.contactCommonConf[0];
          this.dtitle = "财务负责人详情";
          this.dialogVisible = true;
          break;
      }
    },

    closeDialog() {
      this.dialogVisible = false;
    },
    closeDialog1() {
      this.dialogOnes = false;
    },

    convernSexData(data) {
      data.forEach((item) => {
        //item.gender = item.gender == true ? "男" : "女";
        //item.workQualification = item.workQualification === true ? "是" : "否"
        // item.birthday = item.birthday
        //   ? this.$moment(item.birthday).format("YYYY-MM-DD")
        //   : "";
        item.personType = item.personType == 2 ? "法定代表人(或委派代表)" : "";
      });
      return data;
    },

    converInverstorData(value) {
      const data = this.$lodash.cloneDeep(value);
      data.forEach((item) => {
        item.qualified = item.qualified ? "是" : "否";
      });

      return data;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }

        const values = data.map((item) => {
          if (column.property === "capture") {
            return Number(item[column.property]);
          } else if (column.property === "capturePercent") {
            return Number(item[column.property]);
          }
        });
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2) + "";
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    convernOtherData(data) {
      /* console.log(data);
      console.log("~~!~~"); */

      if (!data || !Object.keys(data).length) return;
      this.companyData = [];
      this.officeData = [];
      //this.otherData = [];
      let companyData = {
        regulationOrignName: data.regulationOrignName,
        checkNoticeOrignName: data.checkNoticeOrignName,
      };
      this.companyData.push(companyData);

      let officeData = {
        office:
          data.office[0].officeProvince +
          data.office[0].officCity +
          data.office[0].officDistrict,
        realOfficeAddress: data.office[0].realOfficeAddress,
        officeArea: data.office[0].officeArea,
        officRentOrignName: data.office[0].officRentOrignName,
      };
      this.officeData.push(officeData);
      this.otherData = otherInfoItem;
      let otherDataValue;
      /* console.log(this.otherData);
      console.log("~~!2!!~~");
      console.log(otherInfoItem);
      console.log("~~!!2!~~"); */
      if (this.isAgency) {
        //this.otherData = otherInfoItem;
        /* console.log("~~1@@~~");
        console.log(data.other[0]); */

        switch (this.Cookies.get("fundType")) {
          case "私募股权投资基金":
            //入驻申请书
            this.otherInfoItem[0][0].oldFile =
              data.other[0].inApplicationOrignName;
            // this.otherData[0].newFile = data.other[0].inApplicationStorePath;
            //公司章程或合伙协议
            this.otherInfoItem[0][1].oldFile =
              data.other[0].regulationOrignName;
            // this.otherData[1].newFile = data.other[0].regulationStorePath;
            //私募基金管理人营业执照
            this.otherInfoItem[0][2].oldFile =
              data.other[0].smfundMgrPicOrignName;
            // this.otherData[2].newFile = data.other[0].smfundMgrPicStorePath;
            //中国证券投资基金业协会登记佐证材料（提供管理人登记佐证材料）
            this.otherInfoItem[0][3].oldFile =
              data.other[0].associationRegisteFileOrignName;
            // this.otherData[3].newFile =
            // data.other[0].associationRegisteFileStorePath;
            //管理人备案承诺书（已备案无须提供，新设必须提供）
            this.otherInfoItem[0][4].oldFile =
              data.other[0].mgrPromiseFileOrignName;
            // this.otherData[4].newFile = data.other[0].mgrPromiseFileStorePath;
            //其他材料
            this.otherInfoItem[0][5].oldFile = data.other[0].otherFileOrignName;
            // this.otherData[5].newFile = data.other[0].otherFileStorePath;

            break;
          case "创业投资基金":
            //入驻申请书
            this.otherInfoItem[0][0].oldFile =
              data.other[0].inApplicationOrignName;
            // this.otherData[0].newFile = data.other[0].inApplicationStorePath;
            //公司章程或合伙协议
            this.otherInfoItem[0][1].oldFile =
              data.other[0].regulationOrignName;
            // this.otherData[1].newFile = data.other[0].regulationStorePath;
            //私募基金管理人营业执照
            this.otherInfoItem[0][2].oldFile =
              data.other[0].smfundMgrPicOrignName;
            // this.otherData[2].newFile = data.other[0].smfundMgrPicStorePath;
            //中国证券投资基金业协会登记佐证材料（提供管理人登记佐证材料）
            this.otherInfoItem[0][3].oldFile =
              data.other[0].associationRegisteFileOrignName;
            // this.otherData[3].newFile =
            //   data.other[0].associationRegisteFileStorePath;
            //管理人备案承诺书（已备案无须提供，新设必须提供）
            this.otherInfoItem[0][4].oldFile =
              data.other[0].mgrPromiseFileOrignName;
            //   this.otherData[4].newFile = data.other[0].mgrPromiseFileStorePath;
            //其他材料
            this.otherInfoItem[0][5].oldFile = data.other[0].otherFileOrignName;
            // this.otherData[5].newFile = data.other[0].otherFileStorePath;
            break;
          case "私募证券投资基金":
            //入驻申请书
            this.otherInfoItem[1][0].oldFile =
              data.other[0].inApplicationOrignName;
            // this.otherData[0].newFile = data.other[0].inApplicationStorePath;
            //公司章程或合伙协议
            this.otherInfoItem[1][1].oldFile =
              data.other[0].regulationOrignName;
            // this.otherData[1].newFile = data.other[0].regulationStorePath;
            //私募基金管理人营业执照
            this.otherInfoItem[1][2].oldFile =
              data.other[0].smfundMgrPicOrignName;
            // this.otherData[2].newFile = data.other[0].smfundMgrPicStorePath;
            //中国证券投资基金业协会登记佐证材料（提供管理人登记佐证材料）
            this.otherInfoItem[1][3].oldFile =
              data.other[0].associationRegisteFileOrignName;
            // this.otherData[3].newFile =
            //   data.other[0].associationRegisteFileStorePath;
            //管理人备案承诺书（已备案无须提供，新设必须提供）
            this.otherInfoItem[1][4].oldFile =
              data.other[0].mgrPromiseFileOrignName;
            // this.otherData[4].newFile = data.other[0].mgrPromiseFileStorePath;
            //第三方托管意向书
            this.otherInfoItem[1][5].oldFile =
              data.other[0].sfTrustedFileOrignName;
            // this.otherData[5].newFile = data.other[0].sfTrustedFileStorePath;
            //其他材料
            this.otherInfoItem[1][6].oldFile = data.other[0].otherFileOrignName;
            // this.otherData[6].newFile = data.other[0].otherFileStorePath;
            break;
          case "持股平台":
            // 入驻申请书
            this.otherInfoItem[2][0].oldFile =
              data.other[0].inApplicationOrignName;
            // this.otherData[0].newFile = data.other[0].inApplicationStorePath;
            //公司章程或合伙协议
            this.otherInfoItem[2][1].oldFile =
              data.other[0].regulationOrignName;
            // this.otherData[1].newFile = data.other[0].regulationStorePath;

            // 佐证材料（主体公司代缴个税佐证材料，或主体公司缴纳社保佐证材料，或主体公司劳动合同，或主体公司关联方佐证材料， 或湖南湘江新区财政局（金融办）和长沙高新区科技金融服务中心认可的其他佐证材料）
            //其他材料
            this.otherInfoItem[2][2].oldFile =
              data.other[0].evidenceFileOrignName;
            // this.otherData[2].newFile = data.other[0].evidenceFileStorePath;
            // 主体公司关于同意设立持股平台的股东会决议
            this.otherInfoItem[2][3].oldFile =
              data.other[0].gdhDecisionOrignName;
            // this.otherData[3].newFile = data.other[0].gdhDecisionStorePath;
            // 被纳入重点上市后备企业名单、新三板挂牌企业或上市公司佐证材料
            this.otherInfoItem[2][4].oldFile =
              data.other[0].newImportEvidenceOrignName;
            // this.otherData[4].newFile =
            //   data.other[0].newImportEvidenceStorePath;
            // 主体公司商事变更登记承诺书
            this.otherInfoItem[2][5].oldFile =
              data.other[0].changeRegistedFileOrignName;
            // this.otherData[5].newFile =
            //   data.other[0].changeRegistedFileStorePath;
            //其他材料
            this.otherInfoItem[2][6].oldFile = data.other[0].otherFileOrignName;
            // this.otherData[6].newFile = data.other[0].otherFileStorePath;
            break;
          case "自有资金投资类企业":
            // 入驻申请书
            this.otherInfoItem[3][0].oldFile =
              data.other[0].inApplicationOrignName;
            // this.otherData[0].newFile = data.other[0].inApplicationStorePath;
            //公司章程或合伙协议
            this.otherInfoItem[3][1].oldFile =
              data.other[0].regulationOrignName;
            // this.otherData[1].newFile = data.other[0].regulationStorePath;
            // 已缴出资额佐证材料
            this.otherInfoItem[3][2].oldFile =
              data.other[0].evidenceFileOrignName;
            // this.otherData[2].newFile = data.other[0].evidenceFileStorePath;
            // 出资人备案承诺书
            this.otherInfoItem[3][3].oldFile =
              data.other[0].mgrPromiseFileOrignName;
            // this.otherData[3].newFile = data.other[0].mgrPromiseFileStorePath;
            // 其他材料（至少三年。。）
            this.otherInfoItem[3][4].oldFile = data.other[0].otherFileOrignName;
            // this.otherData[4].newFile = data.other[0].otherFileStorePath;

            break;
        }
        this.isDone = true;
        this.otherData.push(otherDataValue);
      }
    },
  },

  watch: {
    data: {
      handler(newValue) {
        this.formData = newValue.basic;
        if (this.isAgency) {
          this.fundType = this.formData.fundType;
        }
        /*     if (this.formData.officeNeed === false) {
          this.formData.officeNeed = "否";
        }
        if (this.formData.associationRegisteFinished === false) {
          this.formData.associationRegisteFinished = "否";
        } */
        //this.formData.preIndustry = newValue.basic.preIndustry !== '' ? newValue.basic.preIndustry.split(',') : [];
        if (!this.isChange && this.isAgency) {
          this.formData.investDirection =
            newValue.basic.investDirection !== ""
              ? newValue.basic.investDirection.split(",")
              : [];
          this.isChange = true;
        }
        /*   console.log(newValue);
        console.log("~~~newValue~~~");
        this.formData.associationRegiste === false
          ? (this.formData.associationRegiste = "否")
          : (this.formData.associationRegiste = "是");
        this.formData.caseHad === ""
          ? (this.formData.caseHad = "无")
          : (this.formData.caseHad = this.formData.caseHad);
        if (this.formData.autoManaged == 1) {
          this.formData.autoManaged = "是";
        }
        if (this.formData.autoManaged == 0) {
          this.formData.autoManaged = "否";
        }
        if (this.formData.registeIs == 1) {
          this.formData.autoManaged = "是";
        }
        if (this.formData.registeIs == 0) {
          this.formData.autoManaged = "否";
        } */
        this.title = newValue.basic.institutionName;
        this.investorData = this.converInverstorData(newValue.investor);
        this.contactData = newValue.person.linkman;
        this.legalData = this.convernSexData(newValue.person.expertMgrman);
        //this.complianceData = this.convernSexData(newValue.persons.riskman);
        //this.financialData = newValue.persons.finance;
        this.convernOtherData(newValue.otherInfo);
        /* 
        if (
          this.$route.query.institutionCode === this.formData.institutionCode
        ) {
          this.formConf.splice(7, 0, {
            label: "是否完成中国证券投资基金业协会登记/备案",
            formtype: "select",
            options: [
              {
                label: "是",
                value: '1',
              },
              {
                label: "否",
                value: '0',
              },
            ],
            field: "associationRegisteFinished",
            require: false,
          });
        }
        if (this.formConf.length > 16) {
          this.formConf.splice(8, 1);
        } else return; */
      },
      // immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
.title {
  margin: 20px 0px;
  font-size: 14px;
  color: #6c7885;
}
.item-table {
  margin-top: 50px;
}
.institutiomname {
  font-size: 28px;
  color: #0f1824;
  font-weight: 600;
}
</style>

